// removed by extract-text-webpack-plugin
module.exports = {"modalClasses":"_1Ga-7ddwAsfJBKLnvm2qe5","standardLandingPreview":"_1oN8jXntWA0rsQ0bB5NBTH"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/components/Footer/Footers.css
// module id = 451
// module chunks = 0